<template>
  <v-hover v-slot:default="{ hover }">
    <v-card :elevation="hover ? 8 : 2" color="blue5" @click="doNavigation">
      <v-card-title style="white-space:pre;" class="subtitle-1">
        <span v-if="policy.title">{{ policy.displayOrder + 1 }} - {{ policy.title }} </span>
      </v-card-title>
      <v-card-subtitle>
        <span v-if="policy.calculatedStatus">{{ policy.calculatedStatus }} </span>
        <span v-if="archived">(Archived)</span>
        <span v-if="policy.carrier"> | {{ policy.carrier }}</span>
      </v-card-subtitle>
    </v-card>
  </v-hover>
</template>

<style>
</style>

<script>
import analyticsService from '@/services/shared/analyticsService.js';

export default {
  name: 'PolicySummary',
  props: {
    policy: {
      type: Object,
      default: null
    },
    archived: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      hover: false
    };
  },
  computed: {
    clientId: function () {
      return this.$route.params.clientId;
    }
  },
  methods: {
    doNavigation () {
      analyticsService.sendEvent(this.$gtag, 'Button Click', 'Client', 'Policy Select');
      if ((this.policy || null) === null) return;
      var newPath = `${this.$route.path}/policy/${this.policy.displayOrder}`;
      this.$router.push(newPath);
    }
  }
};
</script>
